// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2ND-G","approved":"Status_approved__39xJv","rejected":"Status_rejected__2RJGD","expired":"Status_expired__143Un","label":"Status_label__Nxpsr"};